import { StatementEdit } from './StatementEdit'
import { StatementList } from './StatementList'
import { StatementShow } from './StatementShow'

export const statements = {
  list: StatementList,
  show: StatementShow,
  edit: StatementEdit,
}
